import './frontend-app-styles.css';
import { SuperbarIcon } from './assets/SuperbarIcon';

const website = import.meta.env.VITE_BG_SITE || `https://superbar.ai`;

export const FrontendApp = () => {
  return (
    <div
      className="container"
      style={{
        height: '200vh',
      }}
    >
      <header
        className={`caddietw-bg-white caddietw-h-[80px] caddietw-border-b caddietw-border-gray-200 caddietw-py-3 caddietw-px-6 caddietw-box-border`}
      >
        <div className="caddietw-flex caddietw-w-auto caddietw-items-center caddietw-h-full">
          <SuperbarIcon />
        </div>
        <div className="caddietw-border"></div>
      </header>
      <main className="root">
        <iframe
          src={website}
          className="h-full w-full origin-top-left rounded-3xl border-none"
          title={`${website?.name || 'Website'} preview in playground`}
          sandbox="allow-same-origin allow-scripts"
          style={{
            width: '100%',
            height: '100%',
          }}
        />
      </main>
    </div>
  );
};

export default FrontendApp;
